import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { USERS } from "@/constants/testIds";

export const ContactFields = ({ form, set }) => (
  <div className="space-y-4 rounded-md border border-slate-200 bg-slate-50 p-4">
    <p className="overline-label">Kontak notifikasi pengingat</p>
    <div className="space-y-2">
      <Label>Email</Label>
      <Input type="email" value={form.email} onChange={set("email")} placeholder="nama@gmail.com" className="bg-white" data-testid={USERS.formEmail} />
    </div>
    <div className="space-y-2">
      <Label>Nomor WhatsApp</Label>
      <Input value={form.wa_phone} onChange={set("wa_phone")} placeholder="08123456789 atau +6281234567890" className="bg-white" data-testid={USERS.formWaPhone} />
      <p className="text-xs leading-relaxed text-slate-500">Pengingat WhatsApp dikirim dari nomor kantor yang terhubung di Fonnte ke nomor ini, hanya untuk booking yang dibuat akun ini.</p>
    </div>
  </div>
);
